import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  message?: string;
  className?: string;
}

const sizeMap = {
  sm: 'w-6 h-6 border-2',
  md: 'w-10 h-10 border-3',
  lg: 'w-14 h-14 border-4',
};

/**
 * Centered loading spinner with copper accent.
 */
export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  message,
  className = '',
}) => {
  return (
    <div className={`flex flex-col items-center justify-center py-16 ${className}`}>
      <div
        className={`${sizeMap[size]} border-[#C5922E] border-t-transparent rounded-full animate-spin`}
      />
      {message && (
        <p className="mt-4 text-sm text-[#6B7280] font-medium">{message}</p>
      )}
    </div>
  );
};
